(function($){
    // Masonry
    var doMasonry = function(){
    	var $grid = $('.grid-masonry').masonry({
            itemSelector: '.grid-item',
            percentPosition: true,
            transitionDuration: 0
        });
        $grid.imagesLoaded().progress(function() {
            $grid.masonry('layout');
        });   
    }
    $(window).load(doMasonry);
})(jQuery);
